import { AdgroupConfig, AdgroupFormData, CampaignFormData, CreateMode } from '@tt4b/ttam-enums';
import { useAdgroupBaseValidate, useStdAccountStore } from '@tt4b/ttam-hooks';
import { computed, defineComponent, PropType, ref, toRefs, watch } from '@vue/composition-api';
import TtamCopyBatchWrap from '@/components/common/batch-wrap/index.vue';
import { useInitDataGet } from './hooks';
import TtamAdGroupName from './ad-group-name/index.vue';
import TtamAdGroupTemplateName from './ad-group-template-name/index.vue';

const name = 'ttam-adgroup-name-compose';
export default defineComponent({
  name,
  components: {
    TtamCopyBatchWrap,
    TtamAdGroupName,
    TtamAdGroupTemplateName,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    batchFormData: {
      type: Array as PropType<Partial<AdgroupFormData>[]>,
      default: () => [],
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
    isNameTemplate: {
      type: Boolean,
      default: false,
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const adGroupNameRef = ref();
    const { adgroupConfig } = toRefs(props);
    const { timezone } = useStdAccountStore();
    const { name: initializeGroupName } = useInitDataGet({ timezone });

    const { nameValidator } = useAdgroupBaseValidate();
    const disabled = computed(() => adgroupConfig.value.disableName);
    const adGroupName = ref(props.adgroupData?.name || initializeGroupName);
    const isInvalid = computed(() => adGroupNameRef?.value?.validateState === 'error');
    const onChange = val => {
      emit('change', val);
    };
    const onNameChange = val => {
      emit('change', val);
      adGroupNameRef.value.validate('blur');
    };
    const onNameTemplateChange = val => {
      emit('nameTemplateChange', val);
    };
    const onAdgroupDataChange = data => {
      emit('adgroupDataChange', data);
      // 批量修改名称后，得更新到nameTemplate对象的prefix中，输入框才能更新文本
      props.isNameTemplate &&
        emit('nameTemplateChange', {
          ...props.adgroupData?.nameTemplate,
          prefix: data.name,
        });
    };
    const onCopyDataChange = data => {
      emit('copyDataChange', data);
    };
    // 缺少watch的话，adGroupName一直不会变的，有问题的
    watch(
      () => props.adgroupData.name,
      newVal => {
        adGroupName.value = newVal;
      },
    );
    return {
      nameValidator,
      adGroupNameRef,
      adGroupName,
      disabled,
      onChange,
      onNameTemplateChange,
      onAdgroupDataChange,
      onCopyDataChange,
      onNameChange,
      isInvalid,
    };
  },
});
